import { toTitleFormat } from "Utilities/helpers";
import { GlobeIcon, LocalIcon, UserShadowIcon } from "Assets";
import { SearchResult, SearchResultConfig } from "../types";

const useSearchResultConfig = () => {
  const getSearchResultProps = (result: SearchResult): SearchResultConfig => {
    switch (result.searchTypeSection) {
      case "community":
        return {
          searchTypeSection: "masterSearch_knowledge",
          mainSectionName: toTitleFormat(result.mainSectionName),
          color: "green",
          pillTextColor: "500",
          pillBgColor: "50",
          pillIcon: GlobeIcon,
        };
      case "local":
        return {
          searchTypeSection: "masterSearch_local",
          mainSectionName: toTitleFormat(result.mainSectionName),
          color: "blue",
          pillTextColor: "600",
          pillBgColor: "50",
          pillIcon: LocalIcon,
        };
      case "me":
        return {
          searchTypeSection: "masterSearch_me",
          mainSectionName: toTitleFormat(result.mainSectionName),
          color: "yellow",
          pillTextColor: "700",
          pillBgColor: "100",
          pillIcon: UserShadowIcon,
        };
      default:
        return {
          searchTypeSection: "masterSearch_local",
          mainSectionName: toTitleFormat(result.mainSectionName),
          color: "blue",
          pillTextColor: "600",
          pillBgColor: "50",
          pillIcon: LocalIcon,
        };
    }
  };

  return { getSearchResultProps };
};

export default useSearchResultConfig;
